<template>
  <div>
    <v-card>
       <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogAvvisoInterventoStato"
      width="800"
    >
      <v-card>
        <v-toolbar dense  color="indigo">
          <v-toolbar-title class="white--text"
            >Avviso di modifiche</v-toolbar-title
          >
          <v-spacer></v-spacer>
            <v-btn
             small
            @click="
              dialogAvvisoInterventoStato = false;
              changeRichiestaStatus();
            "
            >
            <v-icon color="success">mdi-check</v-icon>
            </v-btn
          >
          <v-spacer></v-spacer>
            <v-btn small @click="dialogAvvisoInterventoStato = false">
              <v-icon color="red">mdi-window-close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3>vuoi modificare lo stato della richiesta in completato</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        
        
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text"> INTERVENTI </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <!-- Bottone per aprire intervento form -->
        
        <v-tooltip  bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="!hideInterventoButtom"
              @click="openIntervento"
              v-on="on"
              v-bind="attrs"
              small
              class="mr-5"
            >
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Crea Intervento</span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="activateFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>{{
            this.show_filtri == false ? "Show filters" : "Hide filters"
          }}</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text id="mainCardText" class="mt-3">
        <v-row align="center" justify="center" v-if="show_filtri">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_tipo"
              item-value="des_tipo"
              label="Tipo"
              style="display: inline-block; max-width: 350px"
              v-model="tipo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    tipo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    tipo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_sub_tipo"
              item-value="des_sub_tipo"
              label="Sub Tipo"
              style="display: inline-block; max-width: 350px"
              v-model="sub_tipo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    sub_tipo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    sub_tipo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_oggetto"
              item-value="des_oggetto"
              label="Oggetto"
              style="display: inline-block; max-width: 350px"
              v-model="oggetto_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    oggetto_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    oggetto_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_tipo_manu"
              item-value="des_tipo_manu"
              label="Tipo Manu."
              style="display: inline-block; max-width: 350px"
              v-model="tipo_manu_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    tipo_manu_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    tipo_manu_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_ambito"
              item-value="des_ambito"
              label="Ambito"
              style="display: inline-block; max-width: 350px"
              v-model="ambito_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    ambito_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    ambito_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="loading"
        :items="lista_tabella"
        :headers="headers_etichette"
      >
        <!-- Botton for updating Intervento -->
        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="!hideInterventoButtom"
                @click="updateIntervento(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.des_tipo_manu`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo == 33360"
                color="primary"
              >
                mdi-wrench-clock
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo == 33363"
                color="orange"
              >
                mdi-account-wrench-outline
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo == 33362"
                color="green"
              >
                mdi-magic-staff
              </v-icon>
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                v-show="item.id_tipo == 33361"
                color="red"
                >mdi-fire</v-icon
              >
            </template>
            <span>{{ item.des_tipo_manu }} </span>
          </v-tooltip>
        </template>
        <!-- Botton for deleting the Intervento -->
        <template v-slot:[`item.delete`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="deleteIntervento(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-window-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="dialog_show" fullscreen width="80%">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title>Intervento</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small @click="setIntervento" v-bind="attrs" v-on="on">
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            <v-tooltip  v-if="intervento_sel.id_intervento > -1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-2"  small @click="openAvvissoDialog" v-bind="attrs" v-on="on">
                  <v-icon color="green"> mdi-check </v-icon>
                </v-btn>
              </template>
              <span>Salva E Completa Richiesta</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_show = false"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="error">mdi-keyboard-backspace </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
          <v-row class="mt-1 px-2">
            <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
              <v-autocomplete
                v-model="intervento_sel.id_oggetto"
                :items="macchinaList"
                label="Oggetto"
                :item-text="
                  (item) => `${item.des_macchina} - ${item.cod_macchina}`
                "
                placeholder="Des. Oggetto"
                item-value="id_macchina"
                @change="setValues"
                required
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="3" cols="3">
              <v-autocomplete
                v-model="intervento_sel.id_tipo_get_macchina"
                :items="tipo_macchina_list"
                item-text="des"
                label="Tipo"
                placeholder="des"
                required
                item-value="id_tabella"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="3" md="3">
              <v-autocomplete
                v-model="intervento_sel.id_sub_tipo_macchina"
                :disabled="
                  subtipoList.filter(
                    (elem) =>
                      elem.val_int === intervento_sel.id_tipo_get_macchina
                  ).length === 0
                "
                :items="
                  subtipoList.filter(
                    (el) => el.val_int === intervento_sel.id_tipo_get_macchina
                  )
                "
                label="Sub Tipo Macchina"
                placeholder="Sub Tipo Macchina"
                item-text="des"
                required
                item-value="id_tabella"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="
                      intervento_sel.id_sub_tipo_macchina != null &&
                      intervento_sel.id_sub_tipo_macchina != '' &&
                      intervento_sel.id_sub_tipo_macchina != undefined
                    "
                    color="red"
                    @click="intervento_sel.id_sub_tipo_macchina = null"
                    >mdi-delete</v-icon
                  >
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
              <v-autocomplete
                v-model="intervento_sel.id_tipo"
                :items="tipo_manu_list"
                item-text="des"
                label="Tipo Manutenzione"
                placeholder="Tipo Manutenzione"
                required
                item-value="id_tabella"
              >
                <!-- <template #label>
                  <span class="">Tipo Manutenzione</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="getInterventiSelectListi"
                      tipo="INTERVENTI_TIPO_MANU"
                      nome="Tipo Manutenzione"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template> -->
              </v-autocomplete>
            </v-col>

            <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
              <v-autocomplete
                v-model="intervento_sel.id_ambito"
                :items="ambito_manu_list"
                item-text="des"
                label="Ambito Manutenzione"
                placeholder="Ambito Manutenzione"
                required
                item-value="id_tabella"
              >
                <template #label>
                  <span class="">Ambito Manutenzione</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="getInterventiSelectListi"
                      tipo="INTERVENTI_AMBITO_MANU"
                      nome="Ambito Manutenzione"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
              <v-autocomplete
                v-model="intervento_sel.id_area"
                :items="area_list"
                item-text="des"
                label="Area"
                placeholder="Area"
                required
                item-value="id_tabella"
                class="pb-n1"
              >
                <template #label>
                  <span class="">Area</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="getInterventiSelectListi"
                      tipo="INTERVENTI_AREA"
                      nome="Area"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-textarea
                v-model="intervento_sel.note"
                label="Note"
                placeholder="Note"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-card-subtitle>
            <v-tabs class="mt-5" v-model="tab_contenitore" align-with-title>
              <v-tabs-slider color="transparent"></v-tabs-slider>
              <v-tab
                active-class="py-0 my-0 indigo white--text"
                class="py-0 my-0"
                v-for="item in tabs_Interventi"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-card-subtitle>
          <v-card-text class="mt-4">
            <v-tabs-items v-model="tab_contenitore">
              <v-tab-item>
                <v-row>
                  <v-col cols="8" md="8" sm="8" lg="8">
                    <v-dialog width="900" v-model="dettaglio_dialog">
                      <v-card>
                        <v-toolbar dense color="indigo" class="white--text">
                          <v-toolbar-title>Azione</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                @click="salvaAzione"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="success"> mdi-floppy </v-icon>
                              </v-btn>
                            </template>
                            <span>Salva</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="dettaglio_dialog = false"
                                v-bind="attrs"
                                v-on="on"
                                small
                              >
                                <v-icon color="error">mdi-window-close </v-icon>
                              </v-btn>
                            </template>
                            <span>Close</span>
                          </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                          <v-row>
                            <v-col
                              cols="3"
                              lg="3"
                              md="3"
                              sm="3"
                              class="py-1 mt-6"
                            >
                              <v-autocomplete
                                v-model="azione_sel.id_azione"
                                :items="azione_list"
                                item-text="des"
                                label="Azione"
                                placeholder="Azione"
                                required
                                item-value="id_tabella"
                                class="pb-n1"
                              >
                                <template #label>
                                  <span class="">Azione</span>
                                  <a @click.stop style="pointer-events: all">
                                    <Modules
                                      v-on:dialogModules="
                                        getInterventiSelectListi
                                      "
                                      tipo="INTERVENTI_AZIONE"
                                      nome="Azione"
                                      setaction="settabelle"
                                      getaction="gettabelle"
                                      controller="Magazzino"
                                      filter="validita = 1"
                                      :dati="[{ des: '' }]"
                                    />
                                  </a>
                                </template>
                              </v-autocomplete>
                            </v-col>

                            <v-col class="py-1 mt-6">
                              <DateTimePicker
                                @returnVal="returnVal($event)"
                                title="Start"
                                placeholder="Min (Ora Start)"
                                label="Min (Ora Start)"
                                v-model="azione_sel.ora_start"
                                :key="start"
                                :dataVal="start"
                              />
                            </v-col>
                            <v-col class="py-1 mt-6">
                              <DateTimePicker
                                @returnVal="returnVal($event)"
                                v-model="azione_sel.ora_stop"
                                placeholder="Max (Ora Stop)"
                                label="Max (Ora Stop)"
                                title="Stop"
                                :key="stop"
                                :dataVal="stop"
                              />
                            </v-col>
                            <v-col class="py-1 mt-7">
                              <v-autocomplete
                                v-model="azione_sel.id_persona"
                                :items="utenteList"
                                label="Persona"
                                placeholder="Persona"
                                item-text="nominativo"
                                item-value="id_personale"
                                required
                                multiple
                                chips
                                dense
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="py-1 mt-6">
                              <v-textarea
                                v-model="azione_sel.note"
                                label="Note"
                                placeholder="Note"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <v-card>
                      <v-toolbar dense color="indigo" class="white--text">
                        <v-toolbar-title>Azione</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              small
                              @click="createAzione"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="primary"> mdi-plus </v-icon>
                            </v-btn>
                          </template>
                          <span>Aggiungi</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-row align="center">
                        <v-col cols="12">
                          <v-data-table
                            :loading="loadingazione"
                            :items="DettaglioTabella"
                            :headers="DettaglioHeaders"
                          >
                            <!-- Botton for updating Intervento -->
                            <template v-slot:[`item.edit`]="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="updateDettaglio(item)"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon color="primary">
                                      mdi-pencil
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Modifica </span>
                              </v-tooltip>
                            </template>

                            <!-- Botton for deleting the Intervento -->
                            <template v-slot:[`item.delete`]="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="deleteDettaglio(item)"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon color="error">
                                      mdi-window-close
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>Elimina</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-card outlined>
                  <v-card-text>
                    <v-data-table
                      :items="
                        consuntivi_materiale.filter((e) => e.validita === 1)
                      "
                      :headers="headers_materiale"
                    >
                      <template v-slot:top>
                        <v-toolbar color="indigo" dense>
                          <v-toolbar-title class="white--text">
                            Voci di Costo
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="clickAggiungiSpesa(2)"
                                small
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="primary"> mdi-plus </v-icon>
                              </v-btn>
                            </template>
                            <span>Aggiungi Voce di Costo</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>

                      <!-- Bottone di modifica materiale -->
                      <template v-slot:[`item.modifica`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="clickModificaMateriale(item)"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="primary"> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>Modifica</span>
                        </v-tooltip>
                      </template>

                      <!-- Colonna del costo del materiale -->
                      <template v-slot:[`item.costo_ora`]="{ item }">
                        {{
                          item.costo_ora != null && item.costo_ora != undefined
                            ? item.costo_ora.toString().includes(".") ||
                              item.costo_ora.toString().includes(",")
                              ? (
                                  parseFloat(
                                    item.costo_ora.toString().replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                ).split(",")[0] +
                                "," +
                                (
                                  parseFloat(
                                    item.costo_ora.toString().replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                )
                                  .split(",")[1]
                                  .substr(0, 2)
                              : parseFloat(
                                  item.costo_ora.toString().replace(",", ".")
                                )
                                  .toString()
                                  .replace(".", ",")
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                            : "0,00"
                        }}
                      </template>

                      <!-- Colonna dell'importo cantiere del materiale -->
                      <template v-slot:[`item.importo_cantiere`]="{ item }">
                        {{
                          item.importo_cantiere != null &&
                          item.importo_cantiere != undefined
                            ? item.importo_cantiere.toString().includes(".") ||
                              item.importo_cantiere.toString().includes(",")
                              ? (
                                  parseFloat(
                                    item.importo_cantiere
                                      .toString()
                                      .replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                ).split(",")[0] +
                                "," +
                                (
                                  parseFloat(
                                    item.importo_cantiere
                                      .toString()
                                      .replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                )
                                  .split(",")[1]
                                  .substr(0, 2)
                              : parseFloat(
                                  item.importo_cantiere
                                    .toString()
                                    .replace(",", ".")
                                )
                                  .toString()
                                  .replace(".", ",")
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                            : "0,00"
                        }}
                      </template>

                      <!-- Bottone di eliminazione materiale -->
                      <template v-slot:[`item.elimina`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="deleteCostoMT(item)"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                          </template>
                          <span>Elimina</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <!-- Tab degli Extra -->
              <v-tab-item>
                <v-card outlined>
                  <v-card-text>
                    <v-data-table
                      :items="consuntivi_extra.filter((e) => e.validita === 1)"
                      :headers="headers_extra"
                    >
                      <template v-slot:top>
                        <v-toolbar color="indigo" dense>
                          <v-toolbar-title class="white--text">
                            Voci di Costo
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="clickAggiungiSpesa(3)"
                                small
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon color="primary"> mdi-plus </v-icon>
                              </v-btn>
                            </template>
                            <span>Aggiungi Voce di Costo</span>
                          </v-tooltip>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>

                      <!-- Bottone di modifica extra -->
                      <template v-slot:[`item.modifica`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="clickModificaExtra(item)"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="primary"> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>Modifica</span>
                        </v-tooltip>
                      </template>

                      <!-- Colonna del costo degli extra -->
                      <template v-slot:[`item.costo_ora`]="{ item }">
                        {{
                          item.costo_ora != null && item.costo_ora != undefined
                            ? item.costo_ora.toString().includes(".") ||
                              item.costo_ora.toString().includes(",")
                              ? (
                                  parseFloat(
                                    item.costo_ora.toString().replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                ).split(",")[0] +
                                "," +
                                (
                                  parseFloat(
                                    item.costo_ora.toString().replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                )
                                  .split(",")[1]
                                  .substr(0, 2)
                              : parseFloat(
                                  item.costo_ora.toString().replace(",", ".")
                                )
                                  .toString()
                                  .replace(".", ",")
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                            : "0,00"
                        }}
                      </template>

                      <!-- Colonna dell'importo cantiere degli extra -->
                      <template v-slot:[`item.importo_cantiere`]="{ item }">
                        {{
                          item.importo_cantiere != null &&
                          item.importo_cantiere != undefined
                            ? item.importo_cantiere.toString().includes(".") ||
                              item.importo_cantiere.toString().includes(",")
                              ? (
                                  parseFloat(
                                    item.importo_cantiere
                                      .toString()
                                      .replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                ).split(",")[0] +
                                "," +
                                (
                                  parseFloat(
                                    item.importo_cantiere
                                      .toString()
                                      .replace(",", ".")
                                  )
                                    .toString()
                                    .replace(".", ",")
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
                                  "00"
                                )
                                  .split(",")[1]
                                  .substr(0, 2)
                              : parseFloat(
                                  item.importo_cantiere
                                    .toString()
                                    .replace(",", ".")
                                )
                                  .toString()
                                  .replace(".", ",")
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00"
                            : "0,00"
                        }}
                      </template>

                      <!-- Bottone di eliminazione extra -->
                      <template v-slot:[`item.elimina`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="deleteCostoEX(item)"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                          </template>
                          <span>Elimina</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <GestioneAllegato
                  @click_chiudi="gestione_allegati_visible = false"
                  controller_allegati="Global"
                  controller_caratteristiche_tabella="Manutenzione"
                  :id_riferimento="intervento_sel.id_intervento"
                  :read_only="false"
                  ref="componenteAllegati"
                  :show_save_button="false"
                  @snackbarOpen="snackbarOpen"
                  tipo_allegato="QM_INTERVENTO"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <!-- Dialog di aggiunta del materiale -->
          <v-dialog v-model="dialog_dettaglio_materiale">
            <v-card>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Dettaglio Spese Materiale
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Bottone di salvataggio -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="salvaMateriale"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                  </template>
                  <span>Salva</span>
                </v-tooltip>

                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog_dettaglio_materiale = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Chiudi</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text class="mt-5">
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="6">
                      <v-text-field
                        label="Descrizione"
                        v-model="spesa_sel.des"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <InputSeparatore2
                        label="Importo Totale"
                        v-model="spesa_sel.costo_ora"
                        :decimali_fissi="true"
                        :key="input_materiale_key"
                        :numero_iniziale="spesa_sel.costo_ora"
                        ref="input_materiale"
                      />
                    </v-col>
                  
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Dialog di aggiunta degli extra -->
          <v-dialog v-model="dialog_dettaglio_extra">
            <v-card>
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  Dettaglio Spese Extra
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Bottone di salvataggio -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="salvaExtra" small v-bind="attrs" v-on="on">
                      <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                  </template>
                  <span>Salva</span>
                </v-tooltip>

                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dialog_dettaglio_extra = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Chiudi</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text class="mt-5">
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="6">
                      <v-text-field
                        label="Descrizione"
                        v-model="spesa_sel_extra.des"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <InputSeparatore2
                        label="Importo Totale"
                        v-model="spesa_sel_extra.costo_ora"
                        :decimali_fissi="true"
                        :key="input_extra_key"
                        :numero_iniziale="spesa_sel_extra.costo_ora"
                        ref="input_extra"
                      />
                    </v-col>
                    
                 
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </v-card>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import InputSeparatore2 from "@/components/TOOLS/InputSeparatore2.vue";
import moment from "moment";
import GestioneAllegato from "../../TOOLS/GestioneAllegato.vue";
import DateTimePicker from "../../TOOLS/DateTimePicker.vue";
class Intervento {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_intervento", default_val: -1 },
      { nome: "id_richiesta", default_val: null },

      { nome: "id_oggetto", default_val: null },
      { nome: "des_oggetto", default_val: "" },
      { nome: "id_tipo_get_macchina", default_val: null },
      { nome: "des_tipo", default_val: "" },
      { nome: "id_sub_tipo_macchina", default_val: null },
      { nome: "des_sub_tipo", default_val: "" },
      { nome: "id_tipo", default_val: null },
      { nome: "des_tipo_manu", default_val: "" },
      { nome: "id_ambito", default_val: null },
      { nome: "des_ambito", default_val: "" },
      { nome: "id_area", default_val: null },
      { nome: "des_area", default_val: "" },
      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "azione", default_val: [] },
      { nome: "persona", default_val: [] },
    ];

    return campi;
  }
}
class Azione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_intervento", default_val: -1 },
      { nome: "id_intervento_azione", default_val: -1 },
      { nome: "id_temp", default_val: -1 },
      { nome: "id_azione", default_val: null },
      { nome: "des_azione", default_val: null },
      { nome: "id_persona", default_val: [] },
      { nome: "des_persona", default_val: "" },
      { nome: "ora_start", default_val: null },
      { nome: "ora_stop", default_val: null },
      { nome: "note", default_val: null },

      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: null },
      { nome: "data_ins", default_val: null },
      { nome: "data_mod", default_val: null },
    ];

    return campi;
  }
}
class Spesa_Materiale {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_intervento_costo_materiale", default_val: -1 },
      { nome: "costo_ora", default_val: 0 },
      { nome: "des", default_val: "" },
      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: -1 },
      { nome: "id_intervento", default_val: null },
      { nome: "id_tipo_spesa", default_val: null },
      { nome: "importo_cantiere", default_val: 0 },
      { nome: "ore", default_val: 0 },
      { nome: "id_temp", default_val: -1 },
    ];
    return campi;
  }
}
class Spesa_Extra {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_intervento_costo_extra", default_val: -1 },
      { nome: "costo_ora", default_val: 0 },
      { nome: "des", default_val: "" },
      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: -1 },
      { nome: "id_intervento", default_val: null },

      { nome: "id_tipo_spesa", default_val: null },
      { nome: "importo_cantiere", default_val: 0 },
      { nome: "ore", default_val: 0 },
      { nome: "id_temp", default_val: -1 },
    ];
    return campi;
  }
}
export default {
  name: "",
  components: {
    SnackbarQV,
    GestioneAllegato,
    DateTimePicker,
    InputSeparatore2,
    Modules: () => import("@/components/TOOLS/Modules"),
  },
  props: ["listaInterventi", "tipo", "id_richiesta", "id_oggetto", "id_ambito","hideInterventoButtom"],
  data() {
    return {
      // Variabili d'appoggio
      intervento_sel: new Intervento(),
      azione_sel: new Azione(),
      sub_tipo_search: "",
      oggetto_search: "",
      tipo_search: "",
      ambito_search: "",
      tipo_manu_search: "",
      start: "",
      stop: "",
      input_materiale_key: 0,
      input_extra_key: 0,
      loading: false,
      loadingazione: false,
      
      // Modal
      dialogAvvisoInterventoStato:false,
      show_filtri: false,
      dialog_add: false,
      dialog_show: false,
      dettaglio_dialog: false,
      overlay: false,
      dialog_dettaglio_extra: false,
      dialog_dettaglio_materiale: false,
      // Arrays
      consuntivi_extra: new Array(),
      consuntivi_materiale: new Array(),
      spesa_sel: new Spesa_Materiale(),
      spesa_sel_extra: new Spesa_Extra(),
      famiglia_list: [],
      macchinaList: [],
      tipo_manu_list: [],
      ambito_manu_list: [],
      area_list: [],
      tab_contenitore: [],
      lista_etichette: [],
      tipo_macchina_list: [],
      subtipoList: [],
      lista_tabella: [],
      deletedAzione: [],
      deletedcostoMT: [],
      deletedcostoET: [],
      items_pezzi_visualizzati: [],
      azione_list: [],
      utenteList: [],
      richiestaLista:[],
      headers_extra: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Importo (€)",
          value: "costo_ora",
          sortable: false,
        },

        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_materiale: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des",
          sortable: false,
        },
        {
          text: "Importo (€)",
          value: "costo_ora",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
        },
      ],
      headers_etichette: [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "des_tipo",
          sortable: true,
        },
        {
          text: "Sub Tipo",
          value: "des_sub_tipo",
          sortable: true,
        },
        {
          text: "Oggetto",
          value: "des_oggetto",
          sortable: true,
        },
        {
          text: "Tipo Manu.",
          value: "des_tipo_manu",
          sortable: true,
        },
        {
          text: "Ora Min",
          value: "ora_min",
          sortable: true,
        },
        {
          text: "Ora Max",
          value: "ora_max",
          sortable: true,
        },
        {
          text: "Ambito",
          value: "des_ambito",
          sortable: true,
        },
        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
      tabs_Interventi: ["Personale", "Materiale", "Extra", "Allegati"],
      DettaglioTabella: [],
      DettaglioHeaders: [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Azione",
          value: "des_azione",
          sortable: true,
        },
        {
          text: "Min(Ora Start)",
          value: "ora_start",
          sortable: true,
        },
        {
          text: "Max(Ora Stop)",
          value: "ora_stop",
          sortable: true,
        },
        {
          text: "Persona",
          value: "des_persona",
          sortable: true,
        },
        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
    };
  },
  methods: {
      getRichieste() {
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getrichiesteqm",
          token: localStorage.user_token,
          id_richiesta: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          
          if (res.status === 200) {
            res.data.richieste.sort();
            this.richiestaLista = res.data.richieste;
            console.log('this.richiestaLista :>> ', this.richiestaLista);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    openAvvissoDialog(){
       if (this.intervento_sel.id_richiesta == null) {
         this.$refs.SnackbarQV.print(
          "orange",
          "L'intervento non ha una richiesta associata"
        );
       }else{
         this.dialogAvvisoInterventoStato = true;
       }
    },
    changeRichiestaStatus(){
      if (this.tipo === "ChildComponent") {
       this.$emit("setrichiestacomplete", this.id_richiesta);
      }else{
        let i = this.richiestaLista.findIndex(it=>it.id_richiesta === this.intervento_sel.id_richiesta)
        let richiesta = this.richiestaLista[i]
        richiesta.id_stato = 3
        richiesta.data = moment(richiesta.data).format("YYYY-MM-DD")
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setrichiestaqm",
          token: localStorage.user_token,
          id_richiesta: this.intervento_sel.id_richiesta,
          data: [richiesta],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
           
             

            
                this.$refs.SnackbarQV.print(
                  "success",
                  `Salvataggio avvenuto con successo`
                );
              this.dialogAvvisoInterventoStato = false;
              this.dialog_show = false;
                this.$refs.componenteAllegati.lista_allegati = [];
            
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
             
    
      }

    },
    clickModificaExtra(arg) {
      this.spesa_sel_extra = new Spesa_Extra(arg);
      this.dialog_dettaglio_extra = true;
      this.$nextTick(() => {
        this.$refs.input_extra.numero_iniziale = this.spesa_sel_extra.costo_ora;
        this.$refs.input_extra_cantiere.numero_iniziale =
          this.spesa_sel_extra.importo_cantiere;
      });
    },
    clickModificaMateriale(arg) {
      this.spesa_sel = new Spesa_Materiale(arg);
      this.dialog_dettaglio_materiale = true;
      this.$nextTick(() => {
        this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;
        this.$refs.input_materiale_cantiere.numero_iniziale =
          this.spesa_sel.importo_cantiere;
      });
    },
    clickAggiungiSpesa(arg) {
      if (arg === 1) {
        this.dialog_dettaglio_personale = true;
      } else if (arg === 2) {
        this.spesa_sel.ore = 1;
        this.spesa_sel = new Spesa_Materiale();
        this.spesa_sel.id_tipo_spesa = arg;
        this.spesa_sel.id_intervento = this.intervento_sel.id_intervento;
        this.dialog_dettaglio_materiale = true;
        this.$nextTick(() => {
          this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;
          this.$refs.input_materiale_cantiere.numero_iniziale =
            this.spesa_sel.importo_cantiere;
          this.input_materiale_key = this.input_materiale_key === 0 ? 1 : 0;
        });
      } else if (arg === 3) {
        this.spesa_sel_extra = new Spesa_Extra();
        this.spesa_sel_extra.id_tipo_spesa = arg;
        this.spesa_sel_extra.id_intervento = this.intervento_sel.id_intervento;
        this.spesa_sel_extra.ore = 1;
        this.dialog_dettaglio_extra = true;
        this.$nextTick(() => {
          this.$refs.input_extra.numero_iniziale = this.spesa_sel.costo_ora;
          this.$refs.input_extra_cantiere.numero_iniziale =
            this.spesa_sel.importo_cantiere;
          this.input_extra_key = this.input_extra_key === 0 ? 1 : 0;
        });
      }
    },
    salvaMateriale() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel.costo_ora == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare il costo dell'attività."
        );
        return;
      }

      if (this.spesa_sel.costo_ora < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il costo dell'attività non può essere inferiore a 0."
        );
        return;
      }

      this.spesa_sel.costo_totale =
        this.spesa_sel.costo_ora * this.spesa_sel.ore;
      if (this.spesa_sel.id_temp === -1) {
        this.spesa_sel.id_temp = -moment().valueOf();
        this.consuntivi_materiale.push(Object.assign({}, this.spesa_sel));
      } else {
        for (let i = 0; i < this.consuntivi_materiale.length; i++) {
          if (this.consuntivi_materiale[i].id_temp === this.spesa_sel.id_temp) {
            this.$set(this.consuntivi_materiale, i, this.spesa_sel);
          }
        }
      }
      /* Forzo ulteriormente il reset del campo,
       * altrimenti rischia di non venire resettato. */
      console.log("this.con-mat :>> ", this.consuntivi_materiale);
      this.spesa_sel = new Spesa_Materiale();
      this.$refs.input_materiale.numero_iniziale = this.spesa_sel.costo_ora;

      this.dialog_dettaglio_materiale = false;
    },
    salvaExtra() {
      // Eseguo dei controlli sulla conformità dei valori inseriti.
      if (this.spesa_sel_extra.costo_ora == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Specificare il costo dell'attività."
        );
        return;
      }

      if (this.spesa_sel_extra.costo_ora < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il costo dell'attività non può essere inferiore a 0."
        );
        return;
      }

      this.spesa_sel_extra.costo_totale =
        this.spesa_sel_extra.costo_ora * this.spesa_sel_extra.ore;
      if (this.spesa_sel_extra.id_temp === -1) {
        this.spesa_sel_extra.id_temp = moment().valueOf();
        this.consuntivi_extra.push(Object.assign({}, this.spesa_sel_extra));
      } else {
        for (let i = 0; i < this.consuntivi_extra.length; i++) {
          if (
            this.consuntivi_extra[i].id_temp === this.spesa_sel_extra.id_temp
          ) {
            this.$set(this.consuntivi_extra, i, this.spesa_sel_extra);
          }
        }
      }
      /* Forzo ulteriormente il reset del campo,
       * altrimenti rischia di non venire resettato. */
      console.log("this.con-mat :>> ", this.consuntivi_extra);

      this.spesa_sel_extra = new Spesa_Extra();
      this.$refs.input_extra.numero_iniziale = this.spesa_sel_extra.costo_ora;

      this.dialog_dettaglio_extra = false;
    },
    setValues() {
      let i = this.macchinaList.findIndex(
        (it) => it.id_macchina === this.intervento_sel.id_oggetto
      );
      this.intervento_sel.id_tipo_get_macchina =
        this.macchinaList[i].id_tipo_get_macchina;
      this.intervento_sel.id_sub_tipo_macchina =
        this.macchinaList[i].id_sub_tipo_macchina;
    },
    activateFilters() {
      if (this.show_filtri) {
        this.show_filtri = false;

        this.resetFiltro();
      } else {
        this.show_filtri = true;
      }
    },
    openIntervento() {
      this.dialog_show = true;
      this.intervento_sel = new Intervento();
      this.DettaglioTabella = [];
      this.DettaglioTabellaPersonale = [];
      this.DettaglioTabellaTempo = [];
      this.intervento_sel.id_oggetto = this.id_oggetto;
      this.intervento_sel.id_ambito = this.id_ambito;
        let i = this.macchinaList.findIndex(
        (it) => it.id_macchina === this.intervento_sel.id_oggetto
      );
      this.intervento_sel.id_tipo_get_macchina =
        this.macchinaList[i].id_tipo_get_macchina;
      this.intervento_sel.id_sub_tipo_macchina =
        this.macchinaList[i].id_sub_tipo_macchina;
      this.$refs.componenteAllegati.lista_allegati = [];
    },
    returnVal(obj) {
      switch (obj.title) {
        case "Start":
          this.start = moment(obj.val).format("DD/MM/YYYY HH:mm:ss");
          break;
        case "Stop":
          this.stop = moment(obj.val).format("DD/MM/YYYY HH:mm:ss");
          var ms = moment(this.stop, "DD/MM/YYYY HH:mm:ss").diff(
            moment(this.start, "DD/MM/YYYY HH:mm:ss")
          );
          var d = moment.duration(ms, "milliseconds");
          var hours = Math.floor(d.asHours());
          var mins = Math.floor(d.asMinutes()) - hours * 60;
          this.ore = `${hours}.${mins}`;
          break;
        default:
          break;
      }
    },
    createAzione() {
      let currentdate = moment().format("DD/MM/YYYY hh:mm:ss");
      this.start = currentdate;
      this.azione_sel = new Azione();
      this.azione_sel.ora_start = this.start;
      this.stop = "";
      this.dettaglio_dialog = true;
    },
    salvaAzione() {
      let i = this.azione_list.findIndex(
        (it) => it.id_tabella == this.azione_sel.id_azione
      );
      this.azione_sel.des_azione = this.azione_list[i].des;
      let data = this.azione_sel;
      data.ora_start = this.start;
      data.ora_stop = this.stop;
      for (let index = 0; index < data.id_persona.length; index++) {
        const element = data.id_persona[index];
        i = this.utenteList.findIndex((it) => it.id_personale == element);

        data.des_persona = data.des_persona.concat(
          " , ",
          this.utenteList[i].nominativo
        );
      }

      data.id_persona = data.id_persona.toString();
      if (data.ora_start === null || data.ora_start === "") {
        this.$refs.SnackbarQV.print("orange", `il ora start è vuoto`);
        return;
      }

      // if (data.ora_stop === null || data.ora_stop === "") {
      //   this.$refs.SnackbarQV.print("orange", `il ora stop è vuoto`);
      //   return;
      // }
      if (
        this.azione_sel.id_azione === null ||
        this.azione_sel.id_azione === ""
      ) {
        this.$refs.SnackbarQV.print("orange", `il nome della azione è vuoto`);
        return;
      }
      data.id_utente = localStorage.id;
      data.id_intervento =
        this.intervento_sel.id_intervento !== -1
          ? this.intervento_sel.id_intervento
          : -1;
      if (data.id_temp === -1) {
        data.id_temp = moment().unix();
        this.DettaglioTabella.push(data);
      } else {
        let i = this.DettaglioTabella.findIndex(
          (it) => this.azione_sel.id_temp == it.id_temp
        );
        this.DettaglioTabella.splice(i, 1, this.azione_sel);
      }
      this.dettaglio_dialog = false;
    },
    updateDettaglio(item) {
    
      this.azione_sel = new Azione(item);
      this.azione_sel.id_persona = item.id_persona.split(",");
      this.azione_sel.id_persona = Array.from(
        this.azione_sel.id_persona,
        Number
      );
      this.start = moment(item.ora_start).format("DD/MM/YYYY hh:mm:ss");
      if (item.ora_stop !== null) {
      this.stop = moment(item.ora_stop).format("DD/MM/YYYY hh:mm:ss");
        
      }else{
        this.stop = "";
      }
      

      this.dettaglio_dialog = true;
    },
    deleteDettaglio(item) {
      if (item.id_intervento_azione > -1) {
        item.validita = 0;
        this.deletedAzione.push(item);
      }
      let i = this.DettaglioTabella.indexOf(item);
      this.DettaglioTabella.splice(i, 1);
    },
    deleteCostoMT(item) {
      if (item.id_intervento_costo_materiale > -1) {
        item.validita = 0;
        this.deletedcostoMT.push(item);
      }
      let i = this.consuntivi_materiale.indexOf(item);
      this.consuntivi_materiale.splice(i, 1);
    },
    deleteCostoEX(item) {
      if (item.id_intervento_costo_extra > -1) {
        item.validita = 0;
        this.deletedcostoET.push(item);
      }
      let i = this.consuntivi_extra.indexOf(item);
      this.consuntivi_extra.splice(i, 1);
    },

    updateIntervento(item) {
      this.loadingazione = true;
      this.loadingpersonale = true;
      this.dialog_show = true;

      this.intervento_sel = new Intervento(item);
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getinterventodetail",
          token: localStorage.user_token,
          id_intervento: this.intervento_sel.id_intervento,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.DettaglioTabella = res.data.interventi.azione;
            this.consuntivi_materiale = res.data.interventi.costimateriale;
            this.consuntivi_extra = res.data.interventi.costiextra;

            this.DettaglioTabella.map((it) => {
              moment(it.ora_start).format("DD/MM/YYYY hh:mm:ss");
              moment(it.ora_stop).format("DD/MM/YYYY hh:mm:ss"); 
              
            });
            this.loadingazione = false;
            this.loadingpersonale = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loadingazione = false;
            this.loadingpersonale = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    deleteIntervento(item) {
      let data = item;
      item.id_utente = localStorage.id;
      data.validita = 0;
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setinterventi",
          token: localStorage.user_token,
          id_intervento: data.id_intervento,
          data: [data],
          delete: "1",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {

          if (this.tipo === "ChildComponent") {
            
            this.$emit("updateRichcomp", true);
          } else {
            this.getInterventi();
          }
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Criticità rilevata, codice stato: ${res.status}.`
          );
          this.loading = false;
        }
      });
      let i = this.lista_tabella.indexOf(item);
      this.lista_tabella.splice(i, 1);
    },

    getInterventi() {
      this.lista_tabella = [];
      this.lista_etichette = [];
      this.loading = true;
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getinterventi",
          token: localStorage.user_token,
          id_intervento: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_etichette = res.data.interventi.Table1;
            this.lista_tabella = this.lista_etichette.reverse();
            this.items_pezzi_visualizzati = this.lista_tabella;
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },

    setIntervento() {
      this.overlay = true;
      let data = this.intervento_sel;

      if (data.id_oggetto === null || data.id_oggetto === "") {
        this.$refs.SnackbarQV.print("orange", `il Oggetto è vuoto`);
        return;
      }

      this.id_richiesta != null ? (data.id_richiesta = this.id_richiesta) : "";

      let i = this.macchinaList.findIndex(
        (it) => it.id_macchina == data.id_oggetto
      );
      data.des_oggetto = this.macchinaList[i].des_macchina;
      i = this.tipo_macchina_list.findIndex(
        (it) => it.id_tabella == data.id_tipo_get_macchina
      );
      data.des_tipo = this.tipo_macchina_list[i].des;
      i = this.subtipoList.findIndex(
        (it) => it.id_tabella == data.id_sub_tipo_macchina
      );
      data.des_sub_tipo = this.subtipoList[i].des;
      i = this.tipo_manu_list.findIndex((it) => it.id_tabella == data.id_tipo);
      data.des_tipo_manu = this.tipo_manu_list[i].des;
      i = this.ambito_manu_list.findIndex(
        (it) => it.id_tabella == data.id_ambito
      );
      data.des_ambito = this.ambito_manu_list[i].des;
      i = this.area_list.findIndex((it) => it.id_tabella == data.id_area);
      data.des_area = this.area_list[i].des;
      data.id_utente = localStorage.id;
      data.azione = this.DettaglioTabella;
      data.costimateriale = this.consuntivi_materiale;
      data.costiextra = this.consuntivi_extra;
      for (let index = 0; index < data.azione.length; index++) {
        const element = data.azione[index];

        element.ora_start = moment(
          element.ora_start,
          "DD/MM/YYYY hh:mm:ss"
        ).format("YYYY-MM-DD hh:mm:ss");
        element.ora_stop = moment(
          element.ora_stop,
          "DD/MM/YYYY hh:mm:ss"
        ).format("YYYY-MM-DD hh:mm:ss");
      }

      if (this.deletedAzione.length > 0) {
        this.deletedAzione.map((it) => {
          data.azione.push(it);
        });
      }
      if (this.deletedcostoMT.length > 0) {
        this.deletedcostoMT.map((it) => {
          data.costimateriale.push(it);
        });
      }
      if (this.deletedcostoET.length > 0) {
        this.deletedcostoET.map((it) => {
          data.costiextra.push(it);
        });
      }

      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setinterventi",
          token: localStorage.user_token,
          id_intervento: this.intervento_sel.id_intervento,
          data: [data],
          delete: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.dialog_show = false;
          if (res.status === 200) {
            this.overlay = false;
            if (this.$refs.componenteAllegati) {
              this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
                res.data.result.split(",")[1];
              let resSalvataggio =
                await this.$refs.componenteAllegati.salvaTuttiAllegati();

              if (resSalvataggio) {
                this.$refs.SnackbarQV.print(
                  "success",
                  `Salvataggio avvenuto con successo`
                );

                this.$refs.componenteAllegati.lista_allegati = [];
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  `Aggiungere una descrizione per ogni Allegato.`
                );
              }
            }
            if (this.tipo === "ChildComponent") {
              this.$emit("updateRichcomp", this.id_richiesta);
            } else {
              this.getInterventi();
            }
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
      this.intervento_sel.id_intervento = -1;

      this.dialog_show = false;
      this.overlay = false;
    },
    goBack() {
      if (this.hideInterventoButtom) {
        this.$router.push("/home/production");
      }else{
      this.$router.push("/home/quickmaintenance");
      }
      
    },

    filtra() {
      let items_etichette_tmp = [];
      this.lista_etichette.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.famiglia_search != "" && this.famiglia_search != null) {
        // Faccio un array temporaneo
        const res = [];
        if (this.famiglia_search == "*") {
          this.lista_tabella = this.lista_etichette;
          return;
        }
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.des_famiglia
              .toLowerCase()
              .includes(this.famiglia_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.sub_tipo_search != "" && this.sub_tipo_search != null) {
        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.des_sub_tipo == this.sub_tipo_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.tipo_manu_search != "" && this.tipo_manu_search != null) {
        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.des_tipo_manu == this.tipo_manu_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.oggetto_search != "" && this.oggetto_search != null) {
        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.des_oggetto == this.oggetto_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.tipo_search != "" && this.tipo_search != null) {
        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.des_tipo == this.tipo_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.ambito_search != "" && this.ambito_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_ambito == this.ambito_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      this.lista_tabella = items_etichette_tmp;
    },
    resetTable() {
      this.tipo_search = "";
      this.sub_tipo_search = "";
      this.oggetto_search = "";
      this.tipo_manu_search = "";
      this.ambito_search = "";
      this.lista_tabella = this.lista_etichette;
    },
    resetFiltro() {
      // Resetto i filtri
      this.tipo_search = "";
      this.sub_tipo_search = "";
      this.oggetto_search = "";
      this.tipo_manu_search = "";
      this.ambito_search = "";
      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_etichette;
    },

    snackbarOpen() {
      this.$refs.SnackbarQV.print(
        "orange",
        `Aggiungere ad ogni Allegato dell'attività una descrizione.`
      );
    },
    getInterventiSelectListi() {
      // TO populate the list of select fields
      let req_data = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'INTERVENTI_FAMIGLIA','INTERVENTI_OGGETTO','TIPO_MANUTENZIONE','INTERVENTI_AMBITO_MANU','INTERVENTI_AREA','TIPO_GET_MACCHINA','SUB_TIPO_MACCHINA','INTERVENTI_AZIONE'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", req_data).then((res) => {
        this.famiglia_list = res.data.INTERVENTI_FAMIGLIA;
        this.oggetto_list = res.data.INTERVENTI_OGGETTO;
        this.tipo_manu_list = res.data.TIPO_MANUTENZIONE;
        this.ambito_manu_list = res.data.INTERVENTI_AMBITO_MANU;
        this.area_list = res.data.INTERVENTI_AREA;
        this.tipo_macchina_list = res.data.TIPO_GET_MACCHINA;
        this.subtipoList = res.data.SUB_TIPO_MACCHINA;
        this.azione_list = res.data.INTERVENTI_AZIONE;
      });
    },
  },
  created() {},
  computed: {
    formatDate() {
      return this.date ? moment(this.date).format("DD/MM/YYYY") : "";
    },
  },
  mounted() {

    if (this.tipo != "ChildComponent") {
      this.getInterventi();
      this.getRichieste();
    }
    this.lista_etichette = this.listaInterventi;
    this.lista_tabella = this.lista_etichette;
    this.items_pezzi_visualizzati = this.lista_tabella;
    this.getInterventiSelectListi();
    let manu_detail = {
      controller: "Manutenzione",
      method: "POST",
      richiesta: {
        action: "getlistamacchine",
        token: localStorage.getItem("user_token"),
      },
    };
    this.$store.dispatch("api", manu_detail).then((res) => {
      let macchinaData = res.data.macchine;
      macchinaData.filter((it) => {
        const updateobject = {};
        updateobject.id_macchina = it.id_macchina;
        updateobject.des_macchina = it.des_macchina;
        updateobject.cod_macchina = it.cod_macchina;
        updateobject.id_tipo_get_macchina = it.id_tipo_get_macchina;
        updateobject.id_sub_tipo_macchina = it.id_sub_tipo_macchina;
        this.macchinaList.push(updateobject);
        return this.macchinaList;
      });
      let i = this.macchinaList.findIndex(
        (it) => it.id_macchina == this.id_oggetto
      );
      this.intervento_sel.id_oggetto = this.id_oggetto;
      this.intervento_sel.id_tipo_get_macchina =
        this.macchinaList[i].id_tipo_get_macchina;
      i = this.subtipoList.findIndex(
        (it) => it.val_int === this.intervento_sel.id_tipo_get_macchina
      );
      if (i > -1) {
      this.intervento_sel.id_sub_tipo_macchina = this.subtipoList[i].id_tabella;
      }
    });
    let getUtenteList = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "getutenti",
        token: localStorage.getItem("user_token"),
      },
    };
    this.$store.dispatch("api", getUtenteList).then((res) => {
      this.utenteList = res.data;
    });
  },
  watch: {
    stop: {
      immediate: true,
      deep: true,
      handler() {
        if (this.stop == undefined) {
          this.stop = "";
        }
      },
    },

    date(val) {
      let value = moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (val !== "") {
        let items_etichette_tmp = [];
        this.lista_etichette.forEach((elem) => {
          items_etichette_tmp.push(elem);
        });

        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.consegna == value) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
        this.lista_tabella = items_etichette_tmp;
      }
    },
  },
};
</script>
<style css>
</style>